import { Component, OnInit } from "@angular/core";
import { CommonService } from "../../services/common.service";
import { ReviewData } from "../../shared/models/review-data";

@Component({
  selector: "app-confirmation",
  templateUrl: "./confirmation.component.html"
})
export class ConfirmationComponent implements OnInit {
  public displayData: ReviewData = {};
  public isLoading: boolean = false;
  public showComments: boolean = false;
  public commentTitle: string;
  public commentList: any;
  public isPub: boolean = false;
  constructor(public commonService: CommonService) { }
  ngOnInit(): void {
    this.displayData = this.commonService.getComfirmationPageData();
  }
}



// WEBPACK FOOTER //
// ./client/views/request/confirmation/confirmation.component.ts